export default __webpack_public_path__ + "static/media/SelfPortrait2.66e14ded.png";